import { useEffect, useState } from 'react';
import { MagnifyingGlass, CaretDown, CaretRight } from '@phosphor-icons/react';
import { twMerge } from 'tailwind-merge';
import { useTableOperation } from '@/features/explore/api/tableOperation';
import { ClickAwayListener, Fade, Popper } from '@mui/material';
import { useRef } from 'react';
import Skeleton from '@/components/Skeleton';
import { map, uniq } from 'lodash';
import Button from '@/components/Button';
import Input from '@/components/Input';

export const FilterDropDownPillTableNew = ({
  title,
  data = [],
  defaultSelectedOptions = [],
  showApplyCancelResetButton = false,
  name,
  caretRight = true,
  onApply = () => {},
  allowEmpty = false,
  selected,
  onResetClick,
  tableOps,
  columnName,
  onCancel,
  actualTableRowCount,
  clickedFilter,
  setFilterOpen,
}) => {
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [searchQueryType, setSearchQueryType] = useState();
  const [allowsEmpty, setAllowEmpty] = useState(allowEmpty);
  const [filterData, setFilterData] = useState(data);
  const [anchorEl, setAnchorEl] = useState();
  const [open, setOpen] = useState(false);
  const arrowBtnRef = useRef();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget || event.current);
    setOpen((prev) => !prev);
    setFilterOpen((prev) => !prev);
  };

  const handleClose = () => {
    setOpen(false);
    setFilterOpen(false);
  };
  useEffect(() => {
    if (defaultSelectedOptions?.length) {
      setSelectedOptions([...defaultSelectedOptions]);
    }
  }, []);

  const isChecked = (value) => {
    return selectedOptions?.includes(value);
  };
  useEffect(() => {
    if (clickedFilter === columnName) {
      handleClick(arrowBtnRef);
    }
  }, [columnName, clickedFilter]);
  const handleChange = (value) => {
    if (isChecked(value)) {
      setSelectedOptions((prev) => {
        return prev.filter((item) => item !== value);
      });
    } else {
      const item = data.find((e) => e === value);
      setSelectedOptions((prev) => [...prev, item]);
    }
  };

  const agentOperation = useTableOperation({
    config: { enabled: false },
  });

  const fetchFilterResults = async () => {
    let clonedData = structuredClone(tableOps.current);
    let value =
      searchQueryType === 'number'
        ? Number(searchQuery)
        : searchQueryType === 'boolean'
        ? searchQuery.toLowerCase() === 'true'
        : searchQuery;
    let dataToSend = {
      conversationId: clonedData.conversationId,
      messageId: clonedData.messageId,
      name: clonedData?.name,
      operation: [{ name: 'search', field: columnName, value: [value] }],
    };
    let result = await agentOperation.mutateAsync(dataToSend);
    if (searchQuery !== '') setFilterData(uniq(map(result.data, columnName)));
  };

  useEffect(() => {
    if (searchQuery !== '') {
      const delayDebounceFn = setTimeout(() => {
        if (actualTableRowCount > 100) fetchFilterResults();
      }, 500);

      return () => clearTimeout(delayDebounceFn);
    } else {
      setFilterData(data);
    }
  }, [searchQuery]);
  useEffect(() => {
    if (filterData.length === 0 && data.length >= 0 && searchQuery === '') {
      setFilterData(data);
    }
  }, [filterData]);
  return (
    <div className="flex items-center justify-center w-full">
      <>
        <Button
          onClick={handleClick}
          className={{
            button: {
              root: 'w-full p-0',
            },
          }}
        >
          <div
            className={twMerge(`w-full flex justify-between items-center`)}
            ref={arrowBtnRef}
          >
            <div>{title}</div>
            <div>{caretRight ? <CaretRight size={15} /> : <CaretDown />}</div>
          </div>
        </Button>
        <Popper
          open={open}
          anchorEl={anchorEl}
          transition
          placement="right-start"
          disablePortal={true}
        >
          {({ TransitionProps }) => (
            <Fade {...TransitionProps} timeout={350}>
              <div className="bg-white p-1 rounded-md shadow-lg card-shadow w-72 mx-5 -mt-1">
                <ClickAwayListener onClickAway={handleClose}>
                  <div>
                    <div className="px-2 pt-3">
                      <Input
                        type={
                          typeof filterData[0] === 'number' ? 'number' : 'text'
                        }
                        leftElem={<MagnifyingGlass size={15} />}
                        placeholder={`Search ${name}`}
                        value={searchQuery}
                        onChange={(e) => {
                          setSearchQueryType(typeof filterData[0]);
                          setSearchQuery(e.target.value);
                        }}
                        showClearInput={true}
                        clearInput={() => setSearchQuery('')}
                        className={{
                          input: {
                            root: 'pr-0',
                          },
                        }}
                      />

                      <div className="text-xs overflow-hidden overflow-ellipsis whitespace-nowrap text-pv-neutral-grey-300 mt-4">
                        {!agentOperation.isLoading
                          ? !searchQuery
                            ? ''
                            : `Relevant Details for ${searchQuery}`
                          : searchQuery
                          ? `Searching within ${columnName} for ${searchQuery}`
                          : null}
                      </div>
                    </div>
                    <div
                      className={twMerge(
                        'flex flex-col px-3 bg-white text-wrap max-h-40 overflow-y-auto my-3',
                        !searchQuery && '-mt-2'
                      )}
                    >
                      {!agentOperation.isLoading ? (
                        filterData
                          .filter((row) =>
                            typeof row === 'string'
                              ? row
                                  ?.toLowerCase()
                                  .includes(searchQuery.toLowerCase())
                              : String(row).includes(searchQuery)
                          )

                          .map((item, index) => {
                            return (
                              <label
                                className="text-left  w-full flex gap-2 py-3 hover:bg-brand-ai-700 text-xs cursor-pointer text-brand-ai-200 select-none px-2"
                                key={index}
                                style={{
                                  textWrap: 'wrap',
                                  alignItems: 'flex-start',
                                }}
                              >
                                <input
                                  value={item}
                                  type="checkbox"
                                  // key={`${item}-${isChecked(item)}`}
                                  checked={isChecked(item)}
                                  onChange={() => handleChange(item)}
                                  style={{ accentColor: '#3661ED' }}
                                />
                                {item}
                              </label>
                            );
                          })
                      ) : (
                        <div className="flex flex-col gap-2">
                          {Array.from({ length: 2 }).map(() => (
                            <>
                              <div className="flex gap-2">
                                <Skeleton
                                  variant="rounded"
                                  width={25}
                                  height={16}
                                  className="bg-pv-neutral-grey-100"
                                />
                                <Skeleton
                                  variant="rounded"
                                  width={160}
                                  height={16}
                                  className="bg-pv-neutral-grey-100"
                                />
                              </div>
                              <div className="flex gap-2">
                                <Skeleton
                                  variant="rounded"
                                  width={25}
                                  height={16}
                                  className="bg-pv-neutral-grey-100"
                                />
                                <Skeleton
                                  variant="rounded"
                                  width={110}
                                  height={16}
                                  className="bg-pv-neutral-grey-100"
                                />
                              </div>
                            </>
                          ))}
                        </div>
                      )}
                    </div>
                    {showApplyCancelResetButton && (
                      <div className="flex justify-between border-t gap-6">
                        <div className="flex flex-row justify-end p-2 gap-2">
                          <Button
                            onClick={() => {
                              setAllowEmpty(true);
                              setSelectedOptions([]);
                              // onResetClick();
                            }}
                            className={{
                              button: {
                                root: `bg-white ${
                                  selectedOptions?.length < 1
                                    ? 'text-brand-ai-1000'
                                    : 'text-brand-ai-100 hover:text-brand-ai-hover-100'
                                } rounded-lg text-xs leading-5 font-normal px-2 border-none shadow-none`,
                              },
                            }}
                            disabled={selectedOptions?.length < 1}
                          >
                            Reset
                          </Button>
                        </div>
                        <div className="flex flex-row justify-end p-2 gap-1">
                          <Button
                            className={{
                              button: {
                                root: `p-0 inline-flex justify-center items-center gap-x-1.5 px-2 py-1.5 text-xs border border-brand-ai-100 text-brand-ai-100`,
                              },
                            }}
                            onClick={() => {
                              onCancel();
                            }}
                          >
                            Cancel
                          </Button>
                          <Button
                            variant="primary"
                            className={{
                              button: {
                                root: `p-0 ml-2 inline-flex justify-center items-center gap-x-1.5 rounded-lg px-3 py-1.5 text-xs border bg-brand-ai-100 hover:bg-brand-ai-hover-100 hover:text-white text-white`,
                              },
                            }}
                            disabled={
                              allowsEmpty
                                ? false
                                : JSON.stringify(defaultSelectedOptions) ===
                                  JSON.stringify(selectedOptions)
                            }
                            onClick={() => onApply(selectedOptions)}
                          >
                            Apply
                          </Button>
                        </div>
                      </div>
                    )}
                  </div>
                </ClickAwayListener>
              </div>
            </Fade>
          )}
        </Popper>
      </>
    </div>
  );
};
